import { DynamicForm, FieldVariant } from '../../../components/form-builder/form-builder.types';
import { of } from 'rxjs';
import { ProfileResponse } from '../profile.service';

interface ProfileFormObjectProps {
  profileData: ProfileResponse | null;
  onSubmit: () => void;
}

export const getProfileFormObject = ({ profileData }: ProfileFormObjectProps): DynamicForm => {
  const firstNameField = {
    label: 'profile.form.firstName.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    props: {
      value: of(profileData?.firstName),
      onChange: (value: string) => {
        if (profileData) {
          profileData.firstName = value;
        }
      },
      placeholder: 'Prénom',
    },
  };

  const lastNameField = {
    label: 'profile.form.lastName.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    props: {
      value: of(profileData?.lastName),
      onChange: (value: string) => {
        if (profileData) {
          profileData.lastName = value;
        }
      },
      placeholder: 'Nom',
    },
  };

  const emailField = {
    label: 'profile.form.email.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    props: {
      value: of(profileData?.email),
      onChange: (value: string) => {
        if (profileData) {
          profileData.email = value;
        }
      },
      placeholder: 'Email',
    },
    isDisabled: of(true),
  };

  const addressField = {
    label: 'profile.form.address.label',
    variant: FieldVariant.TEXT,
    isRequired: false,
    props: {
      value: of(profileData?.address),
      onChange: (value: string) => {
        if (profileData) {
          profileData.address = value;
        }
      },
      placeholder: 'Adresse',
    },
  };

  const mobileField = {
    label: 'profile.form.mobile.label',
    variant: FieldVariant.TEL,
    isRequired: false,
    props: {
      value: of(profileData?.mobile),
      onChange: (value: string) => {
        if (profileData) {
          profileData.mobile = value;
        }
      },
      placeholder: 'Mobile',
    },
  };

  const fixeField = {
    label: 'profile.form.fixe.label',
    variant: FieldVariant.TEL,
    isRequired: false,
    props: {
      value: of(profileData?.fixe),
      onChange: (value: string) => {
        if (profileData) {
          profileData.fixe = value;
        }
      },
      placeholder: 'Fixe',
    },
  };

  return {
    title: 'profile.form.title',
    description: 'profile.form.description',
    isHeaderHidden: true,
    grids: [
      {
        title: 'profile.form.personalInfo',
        isHeaderHidden: false,
        gridItems: [
          {
            fields: [firstNameField, lastNameField],
          },
          {
            fields: [emailField],
          },
        ],
      },
      {
        title: 'profile.form.contactInfo',
        isHeaderHidden: false,
        gridItems: [
          {
            fields: [addressField],
          },
          {
            fields: [mobileField, fixeField],
          },
        ],
      },
    ],
  };
};
